




















































import Vue from 'vue';

export default Vue.extend({
  name: 'BasePagination',
  model: {
    prop: 'page',
    event: 'paginate',
  },
  props: {
    page: Number,
    perPage: Number,
    count: Number,
    visiblePagesCount: Number,
  },
  data: () => ({
    currentPage: 1,
  }),
  computed: {
    pages(): number {
      return Math.ceil(this.count / this.perPage);
    },

    paginationTriggers(): unknown[] {
      const pageCount: number = this.pages;
      const visiblePagesThreshold: number = Math.round((this.visiblePagesCount - 1) / 2);
      const pagintationTriggersArray: number[] = Array(this.visiblePagesCount - 1).fill(0);
      let pagintationTriggers: unknown[] = [];

      this.firstPage();
      if (pageCount <= this.visiblePagesCount) {
        for (let i = 1; i < pageCount + 1; i += 1) {
          pagintationTriggers.push(i);
        }
        return pagintationTriggers;
      }

      if (this.currentPage === pageCount - (visiblePagesThreshold + 1)) {
        pagintationTriggersArray[0] = this.currentPage - visiblePagesThreshold;
        pagintationTriggers = (pagintationTriggersArray).map(
          (paginationTrigger, index) => pagintationTriggersArray[0] + index,
        );
        pagintationTriggers.unshift(1, '...');
        pagintationTriggers.push('...', pageCount);
        return pagintationTriggers;
      }
      if (this.currentPage <= visiblePagesThreshold + 1) {
        pagintationTriggersArray[0] = 1;
        pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => pagintationTriggersArray[0] + index,
        );
        pagintationTriggers.push('...', pageCount);
        return pagintationTriggers;
      }
      if (this.currentPage >= pageCount - visiblePagesThreshold - 1) {
        pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => pageCount - index,
        );
        pagintationTriggers.reverse().unshift(1, '...');
        return pagintationTriggers;
      }
      pagintationTriggersArray[0] = this.currentPage - visiblePagesThreshold + 1;
      pagintationTriggers = (pagintationTriggersArray).map(
        (paginationTrigger, index) => pagintationTriggersArray[0] + index,
      );
      pagintationTriggers.unshift(1, '...');
      pagintationTriggers.push('...', pageCount);

      return pagintationTriggers;
    },
  },
  methods: {
    paginate(clickPage: string): void {
      this.$emit('paginate', +clickPage);
      this.currentPage = +clickPage;
    },
    firstPage(): void {
      if (this.page === 1) {
        this.currentPage = 1;
      }
    },
  },
});
